import { Column, Entity, Index, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, ManyToOne, JoinColumn } from "typeorm";
import { LocationsEntity } from "../../master-locations/master-locations.entity";

@Entity('sample_storage_location')
export class StorageLocation {

    @PrimaryGeneratedColumn("increment", { name: 'storage_location_id' })
    storageLocationId:number;

    @Column("int", {
        nullable: true,
        name: "sample_request_id",
    })
    sampleRequestId: number;
    
    @Column("int", {
        nullable: true,
        name: "quantity",
    })
    quantity: number;

    @Column("int", {
        nullable: true,
        name: "location",
    })
    location: number;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: string;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @Column('boolean', {
        nullable: false,
        name: 'is_active',
        default: true
    })
    isActive: boolean;

    @ManyToOne(type => LocationsEntity, location => location.storageLocationInfo,{nullable:false})
    @JoinColumn({name:'location'})
    locationInfo: LocationsEntity
}